const rankingItems = [
  { rank: 1, title: '星际穿越', tag: '科幻巨制', score: '9.4', hot: '本周最热', imgSrc: 'https://readdy.ai/api/search-image?query=A%20deep%20space%20abstract%20composition%20with%20warm%20golden%20light%20rays%2C%20cosmic%20atmosphere%2C%20elegant%20cinematic%20aesthetic%2C%20dark%20background%20with%20coral%20accents&width=112&height=112&seq=rank-interstellar&orientation=squarish' },
  { rank: 2, title: '肖申克的救赎', tag: '经典必看', score: '9.7', hot: '评分最高', imgSrc: 'https://readdy.ai/api/search-image?query=A%20warm%20hopeful%20atmosphere%20with%20soft%20golden%20sunlight%2C%20abstract%20freedom%20theme%2C%20elegant%20minimal%20composition%2C%20cinematic%20lighting&width=112&height=112&seq=rank-shawshank&orientation=squarish' },
  { rank: 3, title: '盗梦空间', tag: '悬疑烧脑', score: '9.3', hot: '讨论热榜', imgSrc: 'https://readdy.ai/api/search-image?query=A%20surreal%20dreamlike%20abstract%20composition%20with%20layered%20geometric%20patterns%2C%20warm%20amber%20and%20coral%20tones%2C%20cinematic%20mystery%20atmosphere&width=112&height=112&seq=rank-inception&orientation=squarish' },
  { rank: 4, title: '千与千寻', tag: '动画经典', score: '9.4', hot: '热度飙升', imgSrc: 'https://readdy.ai/api/search-image?query=A%20soft%20dreamy%20abstract%20composition%20with%20warm%20pastel%20gradients%2C%20gentle%20flowing%20shapes%2C%20whimsical%20atmosphere%2C%20elegant%20animation%20aesthetic&width=112&height=112&seq=rank-spirited&orientation=squarish' },
  { rank: 5, title: '霸王别姬', tag: '国产巅峰', score: '9.6', hot: '经典重温', imgSrc: 'https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20composition%20with%20traditional%20Chinese%20opera%20mask%20inspiration%2C%20warm%20crimson%20and%20gold%20tones%2C%20elegant%20cinematic%20lighting&width=112&height=112&seq=rank-farewell&orientation=squarish' },
  { rank: 6, title: '蝙蝠侠：黑暗骑士', tag: '超英标杆', score: '9.2', hot: '新入榜', imgSrc: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20cinematic%20composition%20with%20warm%20orange%20glow%20against%20deep%20shadows%2C%20heroic%20silhouette%20aesthetic%2C%20elegant%20noir%20atmosphere&width=112&height=112&seq=rank-darkknight&orientation=squarish' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时热度排行，发现大家都在看的高分好片
          </p>
        </div>

        <div className="space-y-3">
          {rankingItems.slice(0, 6).map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold text-lg ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={item.imgSrc}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-accent-600 font-medium flex items-center gap-0.5">
                    <i className="ri-star-fill text-xs"></i>
                    {item.score}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-foreground-400">{item.tag}</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-0.5">
                    <i className="ri-fire-line text-xs"></i>
                    {item.hot}
                  </span>
                </div>
              </div>

              <a
                href="#"
                className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-foreground-300 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}